import styled from "styled-components";
import colours from "styles/colours";
import fonts, { fontWeights } from "styles/fonts";

export const MiniTileContent = styled.div`
  && {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 300px;
    height: 168px;
    padding-top: 20px;
    gap: 20px;
  }
`;

export const Title = styled.h3`
  && {
    color: ${colours.elexonBlue};
    font-size: ${fonts.xLarge};
    margin: 0;
    font-weight: ${fontWeights.heavy};
  }
`;

export const Text = styled.p`
  && {
    color: ${colours.elexonBlack};
    margin: 0;
    width: 75%;
    min-height: 2.6em;
    text-align: center;
    font-size: ${fonts.smallMedium};
  }
`;
